/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.IPage<defs.basics.BaseCityResponseDto>>;
export function request(params: API.basics.baseCity.page.Params, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseCity/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
